import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var ClickEvent = /*#__PURE__*/function () {
  function ClickEvent() {
    _classCallCheck(this, ClickEvent);
    this.enable = false;
    this.mode = [];
  }
  _createClass(ClickEvent, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
    }
  }]);
  return ClickEvent;
}();